module.exports = __webpack_public_path__ + "img/account.4e53a6cf.svg";